var _excluded = ["title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";
var SvgSearch = function SvgSearch(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Search' : _ref$title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    title: title
  }, props, {
    viewBox: "0 0 48 48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.963,1.926 C8.671,1.926 1.926,8.671 1.926,16.963 C1.926,25.254 8.671,32 16.963,32 C25.255,32 32,25.254 32,16.963 C32,8.671 25.255,1.926 16.963,1.926 L16.963,1.926 Z M46.282,47.644 L28.252,29.614 C25.251,32.294 21.294,33.926 16.963,33.926 C7.609,33.926 0,26.316 0,16.963 C0,7.609 7.609,0 16.963,0 C26.317,0 33.926,7.609 33.926,16.963 C33.926,21.294 32.294,25.251 29.614,28.252 L47.644,46.282 L46.282,47.644 Z"
  }));
};
SvgSearch = pure(SvgSearch);
SvgSearch.displayName = 'SvgSearch';
export default SvgSearch;